import { SxProps } from '@mui/material';

import { theme } from '../../../../themes/main';

export type Style = {
  [selector: string]: SxProps | Style;
};

export const styles: Style = {
  drawerPaper: {
    width: '100%',
  },
  drawerPaperWrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    mx: 'auto',
  },
  drawerHeader: {
    px: { xs: 5, lg: 12 },
  },
  closeButton: {
    px: { xs: 5, lg: 0 },
    py: { xs: 8, lg: 8 },
    width: '100%',
    justifyContent: 'flex-start',
    fontWeight: theme.typography.fontWeightBold,
    gap: 3,
    '&:focus-visible, &.Mui-focused': {
      outline: `2px solid ${theme.palette.action.focus}`,
      outlineOffset: '-2px',
      borderRadius: '6px',
    },
  },
  closeButtonSvgSM: {
    display: { lg: 'none' },
    fontSize: { xs: '18px' },
  },
  closeButtonSvgLG: {
    display: { xs: 'none', lg: 'block' },
    fontSize: { lg: '24px' },
  },
  drawerContent: {
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    px: { xs: 5, sm: 8, md: 14, lg: 12 },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 5, lg: 6 },
  },
  contentTitle: {
    p: { xs: 5, lg: 6 },
    mt: { xs: 5, lg: 6 },
  },
  contentFilters: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 5, lg: 6 },
    '& .MuiFormControl-root:not(.estate-input)': {
      mt: { xs: 3, lg: 4 },
    },
  },
  drawerFooter: {
    px: { xs: 5, sm: 8, md: 14, lg: 12 },
  },
  buttonGrid: {
    p: 5,
    mx: 'auto',
    maxWidth: { lg: `calc(${theme.spacing(5)} * 3 + 600px) ` },
  },
};
